var InboundSSOAuthFactory = function ($resource, $window) {
    return $resource(
        __authenticationUrl__ + "rest/nonauth/inBoundSSOValidation",
        {},
        {
            query: {
                method: "POST",
                isArray: false
            }
        }
    );
};

InboundSSOAuthFactory.$inject = ["$resource", "$window"];
export default InboundSSOAuthFactory;
